<template>
  <fragment>
    <div class="photo-preview">
      <div
        v-if="avatarFileUrl"
        class="user-avatar"
        :style="{ backgroundImage: `url(${avatarFileUrl})` }"
      />
      <div v-else class="user-avatar" />
      <h2>Profile Photo</h2>
    </div>
    <p>
      <slot />
    </p>
    <input
      id="avatarFile"
      ref="avatarFilePicker"
      style="display: none"
      type="file"
      name="avatarFile"
      accept="image/*"
      @change="onAvatarFileChange"
    />
    <button
      type="button"
      class="btn btn-secondary upload-btn"
      @click="addAvatarFile"
    >
      <span v-if="saving">
        <font-awesome-icon
          :spin="true"
          :icon="['fas', 'spinner']"
          class="icon alt"
        />
      </span>
      <span v-else>
        <font-awesome-icon :icon="['fas', 'upload']" />
        &nbsp;Upload
      </span>
    </button>
  </fragment>
</template>

<script>
import UserClient from '@/api/UserClient';

export default {
  name: 'ProfilePhotoBlock',

  data() {
    return {
      userClient: new UserClient(this.$http),

      saving: false,

      avatarFileUrl: null
    };
  },

  mounted() {
    const user = this.$store.getters.currentUser;
    this.avatarFileUrl = user.photo ? user.photo.url : null;
  },

  methods: {
    addAvatarFile() {
      this.$refs.avatarFilePicker.click();
    },

    async onAvatarFileChange(event) {
      const files = event.target.files || [];
      const avatarFile = files.length ? files[0] : null;

      if (!avatarFile) {
        return;
      }

      this.saving = true;

      try {
        const avatarPhotoMeta = await this.userClient.getSignedUploadUrl();
        await UserClient.saveFile(avatarPhotoMeta.signed_url, avatarFile);

        const savedUser = await this.userClient.saveProfilePhoto(
          avatarPhotoMeta.id
        );

        const user = this.$store.getters.currentUser;
        user.photo = savedUser.photo;
        this.$store.commit('setUser', user);

        this.avatarFileUrl = savedUser.photo.url;
      } catch (e) {
        this.$store.commit('setGlobalAlert', {
          msg: 'Failed to save avatar. Please try again!',
          error: true
        });
      }

      this.saving = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.photo-preview {
  display: flex;
  flex-direction: column;

  .user-avatar {
    @include background-cover;
    @include border-radius(55px);

    background-image: url('~@/assets/img/default-user.jpg');
    height: 110px;
    width: 110px;
    align-self: center;
    margin-bottom: 1rem;
  }

  h2 {
    display: inline-block;
    vertical-align: top;
    font-size: 28px;
    margin-bottom: 0;
    line-height: 40px;
    padding-top: 0;
    white-space: nowrap;
  }
}

button {
  width: 100%;
  margin-top: 10px;
}
</style>
